/**
 * Leave Laws JS
 *
 * @since 1.1.0
 */

(() => {
	// Get the state form
	const stateForm = document.getElementById('as-lll-form');

	// No form? Tschüss!
	if (!stateForm) {
		return;
	}

	// Wait for the form submit
	stateForm.addEventListener('submit', (event) => {
		// Stop the form from submitting
		event.preventDefault();

		// Get the selected state
		const state = stateForm.querySelector('select').value;

		// Get the 'data-base-url' attribute
		const baseUrl = stateForm.getAttribute('data-base-url');

		// No base URL? Tschüss!
		if (!baseUrl) {
			alert('There has been an error. Please try again.');
			return;
		}

		// Append the state
		const url = `${baseUrl}/${state}`;

		// Send the user to the selected state
		window.location = url;

		// Return
		return;
	});
})();